module.exports = __webpack_public_path__ + "static/media/notice.57f9654d.png";